import { f as a } from "./addOns-5IZhcbHD.js";
const i = {
  id: "TexasPick3",
  name: "Pick 3",
  style: {
    colorPrimary: "#008e6a",
    fireball: a
  }
};
export {
  i as default
};
